var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "treinamentos-page" },
    [
      _c(
        "b-card",
        { staticClass: "mb-3 header-card", attrs: { "no-body": "" } },
        [
          _c(
            "b-card-body",
            {
              staticClass:
                "d-flex align-items-center justify-content-between flex-wrap"
            },
            [
              _c("div", [
                _c("h3", { staticClass: "mb-1" }, [
                  _c("i", {
                    staticClass: "fa fa-graduation-cap text-primary mr-2"
                  }),
                  _vm._v("Treinamentos")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-muted mb-0" }, [
                  _vm._v("Vídeos e materiais de capacitação para revendedoras")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.podeGerenciarCategorias
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mr-2",
                          attrs: { variant: "outline-primary", size: "sm" },
                          on: {
                            click: function($event) {
                              return _vm.openCategoryModal()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-folder-plus" }),
                          _vm._v(" Nova Categoria\n        ")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.podeGerenciarTreinamentos
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "primary", size: "sm" },
                          on: {
                            click: function($event) {
                              return _vm.openTrainingModal()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus" }),
                          _vm._v(" Novo Treinamento\n        ")
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.categorias.length
        ? _c("div", { staticClass: "text-center text-muted py-5" }, [
            _c("i", { staticClass: "fa fa-folder-open fa-3x mb-3" }),
            _vm._v(" "),
            _c("p", [_vm._v("Nenhuma categoria cadastrada ainda.")])
          ])
        : _c(
            "b-tabs",
            {
              attrs: {
                pills: "",
                vertical: "",
                "nav-wrapper-class": "treinamentos-tabs-nav",
                "content-class": "pl-md-4"
              },
              model: {
                value: _vm.tabAtiva,
                callback: function($$v) {
                  _vm.tabAtiva = $$v
                },
                expression: "tabAtiva"
              }
            },
            _vm._l(_vm.categorias, function(categoria) {
              return _c(
                "b-tab",
                {
                  key: categoria.id,
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-between"
                              },
                              [
                                _c("span", [_vm._v(_vm._s(categoria.nome))]),
                                _vm._v(" "),
                                _c(
                                  "b-badge",
                                  {
                                    staticClass: "ml-2",
                                    attrs: { pill: "", variant: "light" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.treinamentosPorCategoria(
                                          categoria.id
                                        ).length
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !categoria.ativo
                              ? _c(
                                  "b-badge",
                                  {
                                    staticClass: "mt-1",
                                    attrs: { variant: "secondary" }
                                  },
                                  [_vm._v("inativa")]
                                )
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-between mb-3"
                    },
                    [
                      _c("div", [
                        _c("h5", { staticClass: "mb-0" }, [
                          _vm._v(_vm._s(categoria.nome))
                        ]),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(categoria.descricao))
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.podeGerenciarCategorias
                        ? _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "outline-secondary",
                                size: "sm"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.openCategoryModal(categoria)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-edit" }),
                              _vm._v(" Editar Categoria\n        ")
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.treinamentosPorCategoria(categoria.id).length === 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "text-muted text-center py-4 border rounded"
                        },
                        [
                          _vm._v(
                            "\n        Nenhum treinamento cadastrado nesta categoria.\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    _vm._l(_vm.treinamentosPorCategoria(categoria.id), function(
                      treinamento
                    ) {
                      return _c(
                        "b-col",
                        {
                          key: treinamento.id,
                          staticClass: "mb-4",
                          attrs: { md: "4" }
                        },
                        [
                          _c(
                            "b-card",
                            {
                              staticClass: "h-100 training-card shadow-sm",
                              attrs: { "no-body": "" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "training-thumb",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewTraining(treinamento)
                                    }
                                  }
                                },
                                [
                                  _vm.youtubeThumb(treinamento.youtube_url)
                                    ? _c("img", {
                                        attrs: {
                                          src: _vm.youtubeThumb(
                                            treinamento.youtube_url
                                          ),
                                          alt: ""
                                        }
                                      })
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "training-thumb-placeholder"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-file-alt fa-2x"
                                          })
                                        ]
                                      ),
                                  _vm._v(" "),
                                  treinamento.youtube_url
                                    ? _c(
                                        "div",
                                        { staticClass: "training-thumb-play" },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-play-circle"
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !treinamento.ativo
                                    ? _c(
                                        "b-badge",
                                        {
                                          staticClass: "training-thumb-badge",
                                          attrs: { variant: "secondary" }
                                        },
                                        [_vm._v("inativo")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-card-body",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c(
                                    "h6",
                                    {
                                      staticClass: "mb-1 text-truncate",
                                      attrs: { title: treinamento.titulo }
                                    },
                                    [_vm._v(_vm._s(treinamento.titulo))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-muted small mb-2 training-desc"
                                    },
                                    [_vm._v(_vm._s(treinamento.descricao))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mb-2" },
                                    [
                                      _vm._l(
                                        _vm.classesArray(
                                          treinamento.perm_classes
                                        ),
                                        function(classe) {
                                          return _c(
                                            "b-badge",
                                            {
                                              key: classe,
                                              staticClass: "mr-1",
                                              attrs: { variant: "info" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.classeLabel(classe)
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      !treinamento.perm_classes
                                        ? _c(
                                            "b-badge",
                                            {
                                              staticClass: "border",
                                              attrs: { variant: "light" }
                                            },
                                            [_vm._v("Todas as classes")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      treinamento.anexos &&
                                      treinamento.anexos.length
                                        ? _c(
                                            "b-badge",
                                            {
                                              staticClass: "border ml-1",
                                              attrs: { variant: "light" }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-paperclip"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    treinamento.anexos.length
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mt-auto d-flex justify-content-between align-items-center"
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            size: "sm",
                                            variant: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.viewTraining(
                                                treinamento
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", { staticClass: "fa fa-eye" }),
                                          _vm._v(
                                            " Visualizar\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.podeGerenciarTreinamentos
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "outline-secondary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openTrainingModal(
                                                        treinamento
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-edit"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "outline-danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.deleteTraining(
                                                        treinamento
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-trash-alt"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            }),
            1
          ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.categoryModal.id ? "Editar Categoria" : "Nova Categoria",
            "ok-title": "Salvar",
            "cancel-title": "Cancelar"
          },
          on: {
            ok: function($event) {
              $event.preventDefault()
              return _vm.saveCategory.apply(null, arguments)
            }
          },
          model: {
            value: _vm.categoryModal.open,
            callback: function($$v) {
              _vm.$set(_vm.categoryModal, "open", $$v)
            },
            expression: "categoryModal.open"
          }
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Nome")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.categoryModal.nome,
                  expression: "categoryModal.nome"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.categoryModal.nome },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.categoryModal, "nome", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Descrição")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.categoryModal.descricao,
                  expression: "categoryModal.descricao"
                }
              ],
              staticClass: "form-control",
              domProps: { value: _vm.categoryModal.descricao },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.categoryModal, "descricao", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _vm.categoryModal.id
            ? _c("div", { staticClass: "form-group form-check" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.categoryModal.ativo,
                      expression: "categoryModal.ativo"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox", id: "categoriaAtiva" },
                  domProps: {
                    checked: Array.isArray(_vm.categoryModal.ativo)
                      ? _vm._i(_vm.categoryModal.ativo, null) > -1
                      : _vm.categoryModal.ativo
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.categoryModal.ativo,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.categoryModal,
                              "ativo",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.categoryModal,
                              "ativo",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.categoryModal, "ativo", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label",
                    attrs: { for: "categoriaAtiva" }
                  },
                  [_vm._v("Ativa")]
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            size: "lg",
            title: _vm.trainingModal.id
              ? "Editar Treinamento"
              : "Novo Treinamento",
            "ok-title": "Salvar",
            "cancel-title": "Cancelar"
          },
          on: {
            ok: function($event) {
              $event.preventDefault()
              return _vm.saveTraining.apply(null, arguments)
            }
          },
          model: {
            value: _vm.trainingModal.open,
            callback: function($$v) {
              _vm.$set(_vm.trainingModal, "open", $$v)
            },
            expression: "trainingModal.open"
          }
        },
        [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-group col-md-8" }, [
              _c("label", [_vm._v("Título")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.trainingModal.titulo,
                    expression: "trainingModal.titulo"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.trainingModal.titulo },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.trainingModal, "titulo", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-4" }, [
              _c("label", [_vm._v("Categoria")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.trainingModal.training_category_id,
                      expression: "trainingModal.training_category_id"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.trainingModal,
                        "training_category_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                _vm._l(_vm.categorias, function(categoria) {
                  return _c(
                    "option",
                    { key: categoria.id, domProps: { value: categoria.id } },
                    [_vm._v(_vm._s(categoria.nome))]
                  )
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Descrição")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.trainingModal.descricao,
                  expression: "trainingModal.descricao"
                }
              ],
              staticClass: "form-control",
              attrs: { rows: "2" },
              domProps: { value: _vm.trainingModal.descricao },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.trainingModal, "descricao", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Link do YouTube")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.trainingModal.youtube_url,
                  expression: "trainingModal.youtube_url"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: "https://www.youtube.com/watch?v=..."
              },
              domProps: { value: _vm.trainingModal.youtube_url },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.trainingModal,
                    "youtube_url",
                    $event.target.value
                  )
                }
              }
            }),
            _vm._v(" "),
            _vm.youtubeThumb(_vm.trainingModal.youtube_url)
              ? _c("div", { staticClass: "mt-2" }, [
                  _c("img", {
                    staticClass: "youtube-preview",
                    attrs: {
                      src: _vm.youtubeThumb(_vm.trainingModal.youtube_url)
                    }
                  })
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [
                _vm._v("Classes de distribuidor permitidas "),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(
                    "(deixe todas desmarcadas para liberar a todas as classes)"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("b-form-checkbox-group", {
                attrs: { options: _vm.CLASSES_DISTRIBUIDOR, stacked: "" },
                model: {
                  value: _vm.trainingModal.classes,
                  callback: function($$v) {
                    _vm.$set(_vm.trainingModal, "classes", $$v)
                  },
                  expression: "trainingModal.classes"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [
                _vm._v("Anexos "),
                _c("small", [
                  _vm._v(
                    "(PDF, Word, Excel, PowerPoint ou imagem — máx. 22MB cada)"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("b-form-file", {
                attrs: { multiple: "", placeholder: "Selecione os anexos..." },
                model: {
                  value: _vm.trainingModal.novosAnexos,
                  callback: function($$v) {
                    _vm.$set(_vm.trainingModal, "novosAnexos", $$v)
                  },
                  expression: "trainingModal.novosAnexos"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.trainingModal.anexos && _vm.trainingModal.anexos.length
            ? _c(
                "div",
                { staticClass: "mt-2" },
                _vm._l(_vm.trainingModal.anexos, function(anexo) {
                  return _c(
                    "div",
                    {
                      key: anexo.id,
                      staticClass:
                        "d-flex justify-content-between align-items-center anexo-row"
                    },
                    [
                      _c("span", [
                        _c("i", { staticClass: "fa fa-paperclip" }),
                        _vm._v(" " + _vm._s(anexo.nome_original))
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-danger", size: "sm" },
                          on: {
                            click: function($event) {
                              return _vm.removeAnexo(anexo.id)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-times" })]
                      )
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "lg", title: _vm.viewModal.titulo, "hide-footer": "" },
          model: {
            value: _vm.viewModal.open,
            callback: function($$v) {
              _vm.$set(_vm.viewModal, "open", $$v)
            },
            expression: "viewModal.open"
          }
        },
        [
          _vm.viewModal.youtube_embed_url
            ? _c(
                "div",
                { staticClass: "embed-responsive embed-responsive-16by9 mb-3" },
                [
                  _c("iframe", {
                    staticClass: "embed-responsive-item",
                    attrs: {
                      src: _vm.viewModal.youtube_embed_url,
                      allowfullscreen: ""
                    }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.viewModal.descricao))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-2" },
            [
              _vm._l(_vm.classesArray(_vm.viewModal.perm_classes), function(
                classe
              ) {
                return _c(
                  "b-badge",
                  {
                    key: classe,
                    staticClass: "mr-1",
                    attrs: { variant: "info" }
                  },
                  [_vm._v(_vm._s(_vm.classeLabel(classe)))]
                )
              }),
              _vm._v(" "),
              !_vm.viewModal.perm_classes
                ? _c(
                    "b-badge",
                    { staticClass: "border", attrs: { variant: "light" } },
                    [_vm._v("Todas as classes")]
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.viewModal.anexos && _vm.viewModal.anexos.length
            ? _c("div", [
                _c("h6", [_vm._v("Anexos")]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list-unstyled" },
                  _vm._l(_vm.viewModal.anexos, function(anexo) {
                    return _c("li", { key: anexo.id, staticClass: "mb-1" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.downloadUrl(_vm.viewModal.id, anexo.id),
                            target: "_blank"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-paperclip" }),
                          _vm._v(
                            " " + _vm._s(anexo.nome_original) + "\n          "
                          )
                        ]
                      )
                    ])
                  }),
                  0
                )
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ea192ec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ea192ec","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/treinamentos/Main.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6ea192ec","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/treinamentos/Main.vue
// module chunks = 2